export default __webpack_public_path__ + "static/media/banner.3e557a73.svg";